import React from "react";

const PrivacyPolicyView = () => {
    return (
        <div className="overflow-y-auto bg-gray-50 min-h-screen">
            <div className="max-w-4xl mx-auto px-6 py-10 bg-white shadow-lg rounded-lg">
                <h1 className="text-4xl font-extrabold text-gray-800 mb-10 text-center">개인정보 처리 방침</h1>

                <div className="space-y-10">
                    <p className="text-lg leading-relaxed text-gray-700">
                        주식회사 포티투마루 (이하 "회사"라 함)는 정보통신서비스제공자가 준수하여야 하는 대한민국의 관계 법령 및 개인정보보호 규정을 준수하며 관련 법령에 의거한 개인정보
                        처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.
                    </p>

                    <p className="text-lg leading-relaxed text-gray-700">
                        본 개인정보 처리방침은 회사가 서비스 중인 사이트버니 서비스(이하 '서비스'라 함)에 적용되며, 다음과 같은 내용을 담고 있습니다.
                    </p>

                    {/* 개인정보 처리 방침 목차 */}
                    <ol className="list-decimal list-inside space-y-4 bg-gray-100 p-4 rounded-lg">
                        <li className="text-gray-800 font-medium">수집하는 개인정보의 항목 및 수집방법</li>
                        <li className="text-gray-800 font-medium">개인정보의 수집 및 이용목적</li>
                        <li className="text-gray-800 font-medium">개인정보 공유 및 제공</li>
                        <li className="text-gray-800 font-medium">개인정보의 보유 및 이용기간</li>
                        <li className="text-gray-800 font-medium">개인정보 파기절차 및 방법</li>
                        <li className="text-gray-800 font-medium">이용자 및 법정대리인의 권리와 그 행사방법</li>
                        <li className="text-gray-800 font-medium">개인정보 자동 수집장치의 설치/운영 및 거부에 관한 사항</li>
                        <li className="text-gray-800 font-medium">개인정보의 기술적/관리적 보호대책</li>
                        <li className="text-gray-800 font-medium">연락처 정보</li>
                        <li className="text-gray-800 font-medium">기타</li>
                        <li className="text-gray-800 font-medium">고지의 의무</li>
                    </ol>

                    <section className="space-y-6">
                        <h2 className="text-2xl font-bold text-gray-800">1. 수집하는 개인정보의 항목 및 수집방법</h2>
                        <div className="space-y-4">
                            <h3 className="text-lg font-semibold text-gray-700">가. 수집하는 개인정보의 항목</h3>
                            <p className="text-gray-600">
                                서비스 이용 과정에서 아래와 같은 개인정보를 수집 및 이용자의 동의 아래 제공받아 이용합니다.
                            </p>
                            <div className="bg-gray-50 p-4 rounded-lg border">
                                <h4 className="font-semibold text-gray-700">[회원가입 시]</h4>
                                <p className="text-gray-600">회원가입을 통한 계정 등록 시 이름, 아이디, 비밀번호, 이메일 주소를 수집</p>
                            </div>
                            <div className="bg-gray-50 p-4 rounded-lg border">
                                <h4 className="font-semibold text-gray-700">[도입 상담, 파트너 신청, 교육 신청, 마케팅 활용 동의 시]</h4>
                                <p className="text-gray-600">
                                    회사명, 이름, 이메일주소, 휴대폰번호, (교육 신청의 경우)직위
                                </p>
                            </div>
                            <div className="bg-gray-50 p-4 rounded-lg border">
                                <h4 className="font-semibold text-gray-700">[이메일 수신허용 신청 시]</h4>
                                <p className="text-gray-600">이름, 신청자 이메일 주소</p>
                            </div>
                            <div className="bg-gray-50 p-4 rounded-lg border">
                                <h4 className="font-semibold text-gray-700">[문의접수 시]</h4>
                                <p className="text-gray-600">(필수) 이메일 주소, 문의내용</p>
                                <p className="text-gray-600">(선택) 첨부파일</p>
                            </div>
                            <div className="bg-gray-50 p-4 rounded-lg border">
                                <h4 className="font-semibold text-gray-700">[공통]</h4>
                                <p className="text-gray-600">서비스 이용과정에서 아래와 같은 정보가 생성되어 수집될 수 있습니다.</p>
                                <li className="text-gray-600">IP Address, 쿠키, 방문 일시, 서비스 이용 기록, 부정 이용 기록, 모바일 서비스 이용 시
                                    단말기 정보(단말장치 식별 고유정보, 단말기 환경정보, 광고 ID, 서비스 이용에 대한 기본 통계), 모바일 단말기 내 설치된 어플리케이션 설치 및
                                    사용이력
                                </li>
                            </div>

                            <h3 className="text-lg font-semibold text-gray-700">나. 개인정보 수집방법</h3>
                            <p className="text-gray-600">회사는 다음과 같은 방법으로 개인정보를 수집합니다.</p>
                            <ul className="list-disc pl-6 space-y-2 text-gray-700">
                                <li>
                                    홈페이지, 모바일기기, 서면양식, 팩스, 전화, 상담 게시판, 이메일, 이벤트 응모, 배송요청
                                </li>
                                <li>
                                    협력회사로부터의 제공
                                </li>
                                <li>
                                    회사는 다음과 같은 방법으로 개인정보를 수집합니다.
                                </li>
                            </ul>
                        </div>
                    </section>

                    <section className="space-y-6">
                        <h2 className="text-2xl font-bold text-gray-800">2. 개인정보의 수집 및 이용목적</h2>
                        <p className="text-gray-600">
                            회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.
                        </p>
                        <ul className="list-disc pl-6 space-y-2 text-gray-700">
                            <li>
                                이용자와 약속한 서비스 제공, 서비스 제공에 따른 본인인증, 구매 및 요금결제, 요금 명세서 전달,
                                상품 및 서비스의 배송을 위하여 개인정보를 이용합니다.
                            </li>
                            <li>
                                회원 가입 의사의 확인, 이용자 본인 확인 및 식별, 회원탈퇴 의사의 확인, 문의사항 또는
                                불만처리 등 회원관리를 위하여 개인정보를 이용합니다.
                            </li>
                            <li>
                                법령 및 이용약관을 위반하는 회원에 대한 이용 제한 조치, 부정 이용 행위를 포함하여 서비스의 원활한 운영에 지장을 주는 행위 및 비인가 행위에 대한 방지 및
                                제재, 계정도용 및 부정거래 방지, 고지사항 전달, 분쟁 조정을 위한 기록보존 등 이용자 보호 및 서비스 운영을 위하여 개인정보를 이용합니다.
                            </li>
                            <li>
                                인구통계학적 특성에 따른 서비스 제공, 접속 빈도 분석, 기능개선, 서비스 이용에 대한 통계, 서비스 분석 및 통계에 기반하여 이용자의 상품 구매 및 서비스
                                이용 성향, 관심, 이용기록 분석 등을 반영한 신규 서비스 제공(개인 맞춤형 상품 추천 서비스 등 포함)등에 개인정보를 이용합니다.
                            </li>
                            <li>
                                이벤트 정보, 광고성 정보 제공 등 이벤트 및 프로모션의 목적 등에 개인정보를 이용할 수 있습니다.
                            </li>
                        </ul>
                    </section>

                    <section className="space-y-6">
                        <h2 className="text-2xl font-bold text-gray-800">3. 개인정보 공유 및 제공</h2>
                        <p className="text-gray-600">
                            회사는 회원의 개인정보를 "2. 개인정보의 수집 및 이용목적"에서 고지한 범위 내에서 사용하며, 회원의
                            사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 회원의 개인정보를 제공하지 않습니다.
                            다만, 아래의 경우에는 예외로 합니다.
                        </p>
                        <ul className="list-disc pl-6 space-y-2 text-gray-700">
                            <li>정보주체가 사전에 동의한 경우</li>
                            <li>서비스 제공에 따른 요금정산을 위해 필요한 경우</li>
                            <li>
                                법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가
                                있는 경우
                            </li>
                        </ul>
                    </section>

                    <section className="space-y-6">
                        <h2 className="text-2xl font-bold text-gray-800">4. 개인정보의 보유 및 이용기간</h2>
                        <p className="text-gray-600">
                            회사는 원칙적으로 회원의 개인정보를 서비스 이용 종료 시 및 회원탈퇴 시까지 보유합니다. 단,
                            개인정보 도용 등으로 원치 않는 회원탈퇴, 데이터 백업 등에 대비하기 위하여 서비스 해지일로부터
                            14일 간 개인정보를 보유하며, 다음의 정보는 각 항에서 명시한 이유로 해당 기간 동안 보존합니다.
                        </p>
                        <div className="bg-gray-50 p-4 rounded-lg border">
                            <h3 className="text-lg font-semibold text-gray-700">가. 회사 내부 방침에 의한 정보 보존 사유</h3>
                            <p className="text-gray-600">부정이용기록</p>
                            <p className="text-gray-600">보존 이유 : 부정이용 방지 및 고객 상담 대응 등</p>
                            <p className="text-gray-600">보존 기간 : 수집일로부터 1년</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg border">
                            <h3 className="text-lg font-semibold text-gray-700">나. 관련법령에 의한 정보 보존 사유</h3>
                            <p className="text-gray-600">상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는
                                관계법령에서 정한 일정한 기간 동안 회원정보를 보존합니다. 이 경우 회사는 보존하는 정보를 그 보존의 목적으로만 이용하며 보존기간은 아래와 같습니다.</p>
                            <p className="text-gray-600">보존 이유 : 부정이용 방지 및 고객 상담 대응 등</p>
                            <ul className="list-disc pl-6 space-y-2 text-gray-700">
                                <li>서비스 이용에 관한 로그기록 보존 이유 : 통신비밀보호법 보존 기간 :3개월</li>
                                <li>소비자의 불만 또는 분쟁처리에 관한 기록 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률 보존 기간 : 3년</li>
                                <li>계약 또는 청약철회 등에 관한 기록 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률 보존 기간 : 5년</li>
                                <li>대금결제 및 재화 등의 공급에 관한 기록 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률 보존 기간 : 5년</li>
                            </ul>
                        </div>
                    </section>

                    <section className="space-y-6">
                        <h2 className="text-2xl font-bold text-gray-800">5. 개인정보 파기절차 및 방법</h2>
                        <p className="text-gray-600">회원의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 개인정보 파기절차 및 방법은
                            다음과 같습니다.</p>
                        <div className="bg-gray-50 p-4 rounded-lg border">
                            <h3 className="text-lg font-semibold text-gray-700">가. 파기절차</h3>
                            <p className="text-gray-600">이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB 로 옮겨져(종이의 경우 별도의 서류함)
                                내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조)일정 기간 저장된 후 파기됩니다. 동 개인정보는 법률에 의한 경우가
                                아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg border">
                            <h3 className="text-lg font-semibold text-gray-700">나. 파기방법</h3>
                            <p className="text-gray-600">종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</p>
                            <p className="text-gray-600">전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</p>
                        </div>
                    </section>

                    <section className="space-y-6">
                        <h2 className="text-2xl font-bold text-gray-800">6. 이용자 및 법정대리인의 권리와 그 행사방법</h2>
                        <p className="text-gray-600">
                            이용자 및 법정 대리인은 언제든지 등록되어 있는 자신(혹은 부모 또는 법정 대리인의 허락을 받은 14세
                            미만 아동의) 개인정보를 조회하거나 수정할 수 있으며, 회사의 개인정보의 처리에 동의하지 않는 경우
                            동의를 거부하거나 가입해지(회원탈퇴)를 요청하실 수 있습니다. 다만, 그러한 경우 서비스의 일부 또는
                            전부 이용이 어려울 수 있습니다.
                        </p>
                        <p className="text-gray-600">이용자 혹은 만 14세 미만 아동의 개인정보 조회 및 수정을 위해서는 ‘개인정보변경’(또는 ‘이용자정보수정’ 등)을,
                            가입해지(동의철회)를 위해서는 “회원탈퇴”를 통하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.
                        </p>
                        <p className="text-gray-600">회사는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 “4. 개인정보의 보유 및 이용기간”에 명시된
                            바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.</p>
                    </section>

                    <section className="space-y-6">
                        <h2 className="text-2xl font-bold text-gray-800">7. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항</h2>
                        <div className="bg-gray-50 p-4 rounded-lg border">
                            <h3 className="text-lg font-semibold text-gray-700">가. 쿠키란</h3>
                            <p className="text-gray-600">회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 회원의 정보를 저장하고 수시로 불러오는
                                "쿠키(cookie)"를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 회원의 브라우저에게 보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의
                                하드디스크에 저장됩니다.</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg border">
                            <h3 className="text-lg font-semibold text-gray-700">나. 쿠키의 사용 목적</h3>
                            <p className="text-gray-600">이용자들이 이용한 회사의 각 서비스와 이용형태 등을 분석하여 이용자에게 최적화된 맞춤형 정보를 제공하기 위하여
                                쿠키를 이용합니다.</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg border">
                            <h3 className="text-lg font-semibold text-gray-700">다. 쿠키의 설치/운영 및 거부</h3>
                            <p className="text-gray-600">회원은 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 회원은 웹 브라우저에서 옵션을 설정함으로써 모든 쿠키를
                                허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다. 다만, 쿠키의 저장을 거부할 경우에는 로그인이 필요한
                                회사의 일부 서비스는 이용에 어려움이 있을 수 있습니다.</p>
                            <div className="">
                                <p className="font-semibold">쿠키 설치 허용 여부를 지정하는 방법</p>
                                <p className="text-gray-700">① Chrome 웹 브라우저</p>
                                <p className="ml-4 text-gray-600">{"우측 상단 메뉴 [설정] > [개인 정보 보호 및 보안] > [사이트 설정] > [쿠키 및 사이트 데이터] 설정"}</p>
                                <p className="text-gray-700">② Edge 웹 브라우저</p>
                                <p className="ml-4 text-gray-600">{"우측 상단 메뉴 [설정] > [쿠키 및 사이트 권한] > [쿠키 및 사이트 데이터 관리 및 삭제] 설정"}</p>
                            </div>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg border">
                            <h3 className="text-lg font-semibold text-gray-700">라. 모바일 서비스에서의 쿠키 설치/운영에 관한 사항</h3>
                            <p className="text-gray-600">회사는 PC 환경과 동일•유사한 인터넷 환경을 모바일 서비스에서도 제공하기 위해 모바일 기기(예: 스마트 폰,
                                태블릿 PC)에서도 "쿠키(cookie)"를 사용할 수 있습니다. 단, 회사는 회원의 명시적인 동의없이 개인정보를 포함하는 제3자의 쿠키를 임의로 수집하지
                                않습니다. 모바일 기기에서도 웹 브라우저 설정 기능에서 쿠키 허용 여부를 선택할 수 있습니다. 모바일 기기의 운영체제 및 웹 브라우저 종류에 따라 다소 상이할
                                수 있지만, 대부분의 경우 모바일 웹 브라우저의 환경 설정을 통해 쿠키허용 여부를 결정하거나, 기존의 쿠키 일체를 삭제할 수 있습니다. 다만 쿠키의 저장을
                                거부할 경우, 로그인이 필요한 일부 서비스의 이용에 불편함이 있을 수 있습니다.</p>
                            <div className="">
                                <p className="font-semibold">쿠키 설치 허용 여부를 지정하는 방법</p>
                                <p className="text-gray-700">① Chrome 웹 브라우저</p>
                                <p className="ml-4 text-gray-600">{"우측 상단 메뉴 [설정] > [고급] > [사이트 설정] > [쿠키] 설정"}</p>
                                <p className="text-gray-700">② Edge 웹 브라우저</p>
                                <p className="ml-4 text-gray-600">{"[설정] > [Safari] > [모든 쿠키 차단] > 설정"}</p>
                            </div>
                        </div>
                    </section>

                    <section className="space-y-6">
                        <h2 className="text-2xl font-bold text-gray-800">8. 개인정보의 기술적/관리적 보호대책</h2>
                        <p className="text-gray-600">
                            회사는 회원의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록
                            안전성 확보를 위하여 기술적/관리적 대책을 강구하고 있습니다.
                        </p>
                        <div className="bg-gray-50 p-4 rounded-lg border">
                            <h3 className="text-lg font-semibold text-gray-700">가. 비밀번호 암호화</h3>
                            <p className="text-gray-600">회원 ID의 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이 알고 있으며, 개인정보의 확인 및 변경도
                                비밀번호를 알고 있는 본인에 의해서만 가능합니다.</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg border">
                            <h3 className="text-lg font-semibold text-gray-700">나. 해킹 등에 대비한 대책</h3>
                            <p className="text-gray-600">회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고
                                있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 회원들의 개인정보나 자료가 누출되거나 손상되지 않도록 방지하고
                                있으며, 암호화 통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을
                                통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg border">
                            <h3 className="text-lg font-semibold text-gray-700">다. 처리 직원의 최소화 및 교육</h3>
                            <p className="text-gray-600">회사의 개인정보관련 처리 직원은 담당자에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고
                                있으며, 담당자에 대한 수시 교육을 통하여 회사 개인정보 처리방침의 준수를 항상 강조하고 있습니다.</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg border">
                            <h3 className="text-lg font-semibold text-gray-700">라. 개인정보보호전담기구의 운영</h3>
                            <p className="text-gray-600">회사는 사내 개인정보보호전담기구 등을 통하여 회사 개인정보 처리방침의 이행사항 및 담당자의 준수여부를 확인하여
                                문제가 발견될 경우 즉시 수정하고 바로잡을 수 있도록 노력하고 있습니다.
                                단, 회원 본인의 부주의나 인터넷상의 문제로 ID, 비밀번호 등 개인정보가 유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지 않습니다.
                            </p>
                        </div>
                    </section>

                    <section className="space-y-6">
                        <h2 className="text-2xl font-bold text-gray-800">9. 연락처 정보</h2>
                        <p className="text-gray-600">
                            회사는 개인정보에 대한 의견수렴 및 회사의 서비스를 이용하는 중 발생하는 모든 개인정보보호 관련 민원을 연락처로 신고하실 수 있습니다. 회사는 회원의 신고사항에 대해
                            신속하게 충분한 답변을 드릴 것입니다.
                        </p>
                        <div>
                            <p className="text-gray-600">이메일: guide@sitebunny.ai</p>
                            <p className="text-gray-600">전화번호: 02-6952-9201</p>
                        </div>
                    </section>

                    <section className="space-y-6">
                        <h2 className="text-2xl font-bold text-gray-800">10. 기타</h2>
                        <p className="text-gray-600">
                            회사가 제공하는 서비스에 링크되어 있는 웹페이지들이 개인정보를 수집하는 행위에 대해서는 본
                            개인정보 처리방침이 적용되지 않음을 알려 드립니다.
                        </p>
                    </section>

                    <section className="space-y-6">
                        <h2 className="text-2xl font-bold text-gray-800">11. 고지의 의무</h2>
                        <p className="text-gray-600">
                            현 개인정보 처리방침의 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 홈페이지의 "공지사항"을 통해 고지할 것입니다.
                        </p>
                        <div>
                            <p className="text-gray-600">
                                버전 : v1.0
                            </p>
                            <p className="text-gray-600">
                                공고일자 : 2025년 1월 1일
                            </p>
                            <p className="text-gray-600">
                                시행일자 : 2025년 1월 1일
                            </p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicyView;
